import { isBoolean } from 'lodash'
import { Maybe } from 'types/graphqlTypes'

/**
 * @returns Formatted loading method.
 */
export const getAwardedLaneLoadingMethod = (
  isPickupDropTrailer: Maybe<boolean>,
  isDeliveryDropTrailer: Maybe<boolean>
) => {
  let pickupMethod = ''
  if (isBoolean(isPickupDropTrailer)) {
    pickupMethod = `${isPickupDropTrailer ? 'Drop' : 'Live'} trailer at pickup`
  }

  let deliveryMethod = ''
  if (isBoolean(isDeliveryDropTrailer)) {
    deliveryMethod = `${isDeliveryDropTrailer ? 'Drop' : 'Live'} trailer at delivery`
  }

  return `${pickupMethod} - ${deliveryMethod}`
}
